import { KioskOrderingStore } from 'kiolyn-api';
import { getTypeOrderKiosk } from './GetTypeOrderKiosk';

export function getApplyTax(store: KioskOrderingStore) {
  const typeKiosk = getTypeOrderKiosk();
  if (!typeKiosk || !store?.area_settings) return true;
  const isApplyTax =
    typeKiosk === 'togo'
      ? store?.area_settings?.is_apply_tax_kiosk_for_togo
      : store?.area_settings?.is_apply_tax_kiosk_for_here;

  return isApplyTax;
}
